import axios from "axios";
import { MDBDataTable } from "mdbreact";
import React from "react";
import * as misConstantes from "../../../../js/constantes.js";
import { Link } from "react-router-dom";
import { formatName } from "../../../../js/util.js";

class OfertaTodosProveedores extends React.Component {
  constructor(props) {
    super(props);

    console.log(props);
    var columnas = [
      {
        field: "proveedor",
        label: "Proveedores",
        attributes: { width: "40%" },
      },
      {
        field: "precioBase",
        label: "Precio Base Sin Impuestos",
        attributes: { width: "20%" },
      },
      {
        field: "precioTechoProveedor",
        label: "Precio Techo Proveedor Sin Impuestos",
        attributes: { width: "20%" },
      },
      {
        field: "precioOfertado",
        label: "Precio Ofertado Con Impuestos",
        attributes: { width: "20%" },
      },

      {
        field: "botones",
        label: "",
        sort: "asc",
        width: "10%",
        attributes: { width: "10%", align: "center" },
      },
    ];

    this.state = {
      datos: { columns: columnas, rows: [] },
      columnas: columnas,
      mostrarActualizarPropuesta: false,
      evaluacion: {},
      producto: "",
      mensaje: "",
      mensajeTabla: "",
    };
  }
  componentDidMount() {
    this.preciosProveedores();
  }

  render() {
    return (
      <>
        {this.state.mensajeTabla}
        <MDBDataTable
          striped
          bordered
          small
          data={this.state.datos}
          hover
          entriesOptions={[50, 100, 250, 500, 1000, 2000]}
          entries={2000}
          pagesAmount={10}
          condensed
        />
        {this.state.mensajeTabla}
      </>
    );
  }

  // ------------------------------------------------------------------------------------------------------
  // ItemSimulacionProveedor
  // ------------------------------------------------------------------------------------------------------
  preciosProveedores() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    console.log(codigo);
    var idCotizacion = this.props.idCotizacion;

    var info = { codigo: codigo, idCotizacion: idCotizacion };

    this.setState({ mensajeTabla: "Cargando" });
    axios
      .post(misConstantes.URL_CONSULTA + "/ServletPreciosProveedores", info, {
        params: info,
      })
      .then(
        function (response) {
          this.setState({ mensajeTabla: "" });
          // alert( JSON.stringify( response.data )  );
          console.log(response.data);
          var items = response.data;
          var rows = [];
          for (var i = 0; i < items.length; i++) {
            console.log(items[i]);

            var row = {
              proveedor: <>{items[i].nombreProveedor}. </>,
              precioBase: <>{items[i].precios.precioBase}</>,
              precioTechoProveedor: items[i].precios.precioTechoProveedor,
              precioOfertado: items[i].precios.precioOfertado,
              botones: (
                <div style={{ width: "100%", textAlign: "center" }}>
                  <Link
                    to={
                      "/cotizacion-proveedor/" +
                      items[i].idSimulacion +
                      "/" +
                      items[i].idProveedor +
                      "/" +
                      formatName(items[i].nombreProveedor)
                    }
                  >
                    <i class="fas fa-info-circle"></i>
                  </Link>
                </div>
              ),
            };
            rows.push(row);
          }

          var columns = this.state.columnas;
          var datos = { columns: columns, rows: rows };
          this.setState({ datos: datos });
        }.bind(this)
      )
      .catch(function (error) {});
  }
}

export default OfertaTodosProveedores;
